module.exports = __webpack_public_path__ + "img/1524164377.d791182b.jpg";